import { UserAccessDetails, UserInfo } from '../types/AccessControl';
import { convertToUUID } from 'uuid-encoding';
import { formatAccessUserRoles } from './formatAccessManagerRole';

export function consolidateUserAccessDetails(
  userDetails: UserAccessDetails,
  channelId: string
): UserInfo {
  const channelAccessUser = userDetails.accessUsers.find(
    user => user.channelId === channelId
  );

  const userChannelRole = userDetails.accessRole.find(
    role => role.channelId === channelId
  );

  const channelCredentials = userDetails.credentialGroups
    .filter(group => group.vtsOrganizationId === channelId)
    .flatMap(group => group.credentials);

  const roles = formatAccessUserRoles(userChannelRole?.accessRoles);

  return {
    _id: userDetails.id,
    name: userDetails.name,
    email: userDetails.primaryEmail,
    syncStatus: channelAccessUser?.syncStatus || '',
    companies: userDetails.companies,
    mobileAccess: channelAccessUser?.mobileAccess || false,
    source: '',
    accessControlGroupIds:
      channelAccessUser?.accessControlGroups.map(group => group.id) || [],
    multiIntegrationAcgs: userDetails.accessUsers.map(user => ({
      channelId: convertToUUID(user.channelId),
      channelName: '',
      accessControlGroups: user.accessControlGroups.map(group => ({
        id: group.id,
        name: group.name,
      })),
    })),
    logo: userDetails.logo,
    image: userDetails.image,
    role: roles[0] || '',  
    roles,
    credentials: channelCredentials,
    integrationChannelId: channelId,
  };
}

export function consolidateMultipleUserAccessDetails(
  usersDetails: UserAccessDetails[],
  channelId: string
): UserInfo[] {
  return usersDetails.map(user =>
    consolidateUserAccessDetails(user, channelId)
  );
}
